import styled from 'styled-components'

import { style } from 'theme'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 30px;
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    padding-bottom: 30px;
  }
`

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0 0;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    width: 100%;
  }
`

export const IraTitle = styled.p`
  color: ${style(theme => theme.colors.slate)};
  font-size: 16px;
  font-weight: 600;
  height: 24px;
  line-height: 24px;
  margin: 0;
`
export const IraSubtext = styled.p`
  flex-grow: 1;
  text-align: start;
  font-weight: normal;
  font-size: 12px;
  color: ${style(theme => theme.colors.stone)};
  margin: auto auto;
  text-decoration: none;
`

export const Detail = styled.p`
  font-size: 14px;
  color: ${style(theme => theme.colors.slate)};
  font-weight: normal;
  ul {
    padding: 0px;
  }
  li {
    padding-bottom: 20px;
  }
`

export const RecommendationText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  text-align: start;
`
